import React, { useEffect } from "react";
import "./ClutchWidget.css";

const ClutchWidgetSmall = () => {
  useEffect(() => {
    // Remove any existing Clutch scripts first
    const existingScripts = document.querySelectorAll('script[src*="widget.clutch.co"]');
    existingScripts.forEach(script => script.remove());

    // Create and append the new script
    const script = document.createElement("script");
    script.src = "https://widget.clutch.co/static/js/widget.js";
    script.async = true;

    // Initialize widget after script loads
    script.onload = () => {
      if (window.CLUTCHCO) {
        window.CLUTCHCO.Init();
      }
    };

    document.body.appendChild(script);

    // Clean up on unmount
    return () => {
      const scriptToRemove = document.querySelector('script[src*="widget.clutch.co"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <div className="clutch-widget-container-small">
      <div
        className="clutch-widget"
        data-url="https://widget.clutch.co"
        data-widget-type="1"
        data-height="40"
        data-nofollow="true"
        data-expandifr="true"
        data-scale="100"
        data-clutchcompany-id="2430366"
      ></div>
    </div>
  );
};

// Add TypeScript declaration for the CLUTCHCO global
declare global {
  interface Window {
    CLUTCHCO?: {
      Init(): void;
    };
  }
}

export default ClutchWidgetSmall; 